module.exports = __webpack_public_path__ + "static/img/epmt.89b4a84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/epmt.svg
// module id = 1RpS
// module chunks = 1